import { useUserPartControllerMyParticipants } from "@/generated/api/api";
import { useAccessTokenClaims } from "./session.ctx";
import { useMemo } from "react";

export function useMyParticipant(organizationId: string) {
  const claims = useAccessTokenClaims();

  const { data: participants, ...rest } = useUserPartControllerMyParticipants();

  const myParticipant = useMemo(
    () => participants?.find((p) => p.organizationId === organizationId),
    [participants, claims]
  );

  return {
    myParticipant,
    ...rest,
  };
}
